// TAO风格化API服务接口
const taoServiceUrls = {
  local: 'http://localhost:3000',
  remote: 'https://vpn.ai7788.cn'
};

// 上传响应接口
export interface UploadResponse {
  status: string;
  serverPath: string;
  publicPath: string;
}

// 风格样式接口
export interface StyleItem {
  styleId: number;
  styleName: string;
  imgUrl: string;
}

// 生成请求接口
export interface GenerateRequest {
  sourceImage: string;
  styleId: number;
}

// 生成响应接口
export interface GenerateResponse {
  status: string;
  filePath: string;
}

class TaoApiService {
  private baseUrl: string = taoServiceUrls.remote; // 默认为remote

  /**
   * 设置TAO API的基础URL
   * @param endpoint 'local' 或 'remote'
   */
  setBaseUrl(endpoint: string) {
    if (endpoint === 'local' || endpoint === 'remote') {
      this.baseUrl = taoServiceUrls[endpoint];
      console.log(`TAO API基础URL已设置为: ${this.baseUrl}`);
    } else {
      console.warn(`无效的TAO endpoint: ${endpoint}，保持当前设置: ${this.baseUrl}`);
    }
  }

  /**
   * 获取当前TAO API的基础URL
   */
  getBaseUrl(): string {
    return this.baseUrl;
  }

  /**
   * 上传原图
   * @param file 图片文件或base64数据
   * @returns 上传响应
   */
  async uploadImage(file: File | string): Promise<UploadResponse> {
    try {
      // 构建FormData
      const formData = new FormData();
      
      if (typeof file === 'string') {
        // 处理base64数据
        const base64Data = file.split(',')[1];
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'image/jpeg' });
        formData.append('file', blob, 'image.jpg');
      } else {
        // 处理File对象
        formData.append('file', file);
      }

      const response = await fetch(`${this.baseUrl}/api/stylization/upload`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      console.log('图片上传成功:', result);
      return result;

    } catch (error) {
      console.error('图片上传失败:', error);
      throw new Error(`图片上传失败: ${error instanceof Error ? error.message : '未知错误'}`);
    }
  }

  /**
   * 获取风格样式列表
   * @returns 风格样式列表
   */
  async getStyleList(): Promise<StyleItem[]> {
    try {
      const response = await fetch(`${this.baseUrl}/api/stylization/styleList`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Get style list failed: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      return result;

    } catch (error) {
      console.error('获取风格样式列表失败:', error);
      throw new Error(`获取风格样式列表失败: ${error instanceof Error ? error.message : '未知错误'}`);
    }
  }

  /**
   * 生成风格化图片
   * @param request 生成请求参数
   * @returns 生成响应
   */
  async generateStylizedImage(request: GenerateRequest): Promise<GenerateResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/api/stylization/generate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
      });

      if (!response.ok) {
        throw new Error(`Generate failed: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      console.log('风格化图片生成成功:', result);
      return result;

      // return Promise.resolve({
      //   status: "success", filePath: "https://vpn.ai7788.cn/api/output\\freshsun\\img_00198_.png"
      // });

    } catch (error) {
      console.error('风格化图片生成失败:', error);
      throw new Error(`风格化图片生成失败: ${error instanceof Error ? error.message : '未知错误'}`);
    }
  }
}

// 创建单例实例
export const taoApi = new TaoApiService();

// 导出类型和类
export { TaoApiService };
